/**
 * 说明
 *
 * 1. 白名单内的路由不需要登录验证
 * 2. 路由视图内的 API 报 401 也不会重定向到 login
 * 3. 跳转到白名单路由前，如果已登录，会跳转并退出登录 (安全问题，因目前 API Token 的使用导致)
 */

const whitelist = [
  /^\/login(\/.*)?$/, // 登录/注册/忘记密码
  /^\/sso-checking(\/.*)?$/, // 登录/注册/忘记密码
  /^\/first-order(\/.*)?$/, // 用户首次下单页
  /^\/first-order2(\/.*)?$/, // 用户首次下单页
  /^\/share(\/.*)?$/, // load share
  /^\/driverInvitation(\/.*)?$/, // driverInvitation
  /^\/.*\/svg-sprite\.svg(\/.*)?$/, // svg-sprite
  /^\/scan-document(\/.*)?$/, // scan-document
  /^\/feedback(\/.*)?$/, // feedback
  /^\/shareTrack(\/.*)?$/, // shareTrack
  /^\/map\/index(\/.*)?$/, // map
  /^\/load-board\/search-loads(\/.*)?$/,
  /^\/market-insights(\/.*)?$/,
  /^\/intercept(\/.*)?$/,
  /^\/sign-up(\/.*)?$/,
  /^\/verify(\/.*)?$/,
  /^\/payments\/landing(\/.*)?$/,
];

if(process.env.NODE_ENV !== 'production') {
  whitelist.push(  /^\/svg-map(\/.*)?$/)
  whitelist.push(/^\/common(\/.*)?$/)
}

function matchWhitelist(path) {
  const list = whitelist.filter(i => !!i);
  return list.some(item => item.test(path))
}
export default matchWhitelist;
